import goto from "./index";

export default {
  miniCourses() {
    goto.context("mini-courses");
  },
};
